document.addEventListener("DOMContentLoaded", () => {
  let isMobile = false;
  let currentTargetPanel = null;
  let currentTargetPanelId = null;

  function setIsMobile() {
    if (window.innerWidth < 1024) {
      isMobile = true;
    } else {
      isMobile = false;
    }
  }

  setIsMobile();
  window.addEventListener("resize", setIsMobile);

  const panels = document.querySelectorAll(".panel");

  function openPanel() {
    if (isMobile) {
      panels.forEach((panel) => {
        panel.style.transform = "";
        panel.ariaHidden = "true";
      });
    }

    if (currentTargetPanelId !== "panel-kontakt") {
      if (isMobile) {
        currentTargetPanel.style.transform = "translateY(0%)";
      } else {
        currentTargetPanel.style.transform = "translateX(0%)";
      }
      currentTargetPanel.ariaHidden = "false";
    } else {
      currentTargetPanel.style.transform = "translateY(0%)";
      currentTargetPanel.ariaHidden = "false";
    }
  }

  function closePanel() {
    if (currentTargetPanel) {
      currentTargetPanel.style.transform = "";
      currentTargetPanel.ariaHidden = "true";
    }
  }

  const panelButtons = document.querySelectorAll(".panel-btn");
  panelButtons.forEach((btn) => {
    const targetPanelId = "panel-" + btn.id.split("-")[1];
    const targetPanel = document.getElementById(targetPanelId);

    btn.addEventListener("click", () => {
      currentTargetPanel = targetPanel;
      currentTargetPanelId = targetPanelId;
      openPanel();
    });
  });

  panels.forEach((panel) => {
    const closeButton = panel.querySelector(".panel__close-btn");

    closeButton.addEventListener("click", () => {
      currentTargetPanel = panel;
      closePanel();
    });
  });

  window.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
      panels.forEach((panel) => {
        panel.style.transform = "";
        panel.ariaHidden = "true";
      });
    }
  });
});
